var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcFleetHover = function SvgIcFleetHover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "terminal_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3567",
    "data-name": "Group 3567",
    transform: "translate(3.188 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_time_to_leave_24px",
    d: "M4.5,4.729A1.079,1.079,0,0,1,5.528,4h7.944a1.086,1.086,0,0,1,1.026.729L16,9.056v5.778a.724.724,0,0,1-.722.722h-.722a.724.724,0,0,1-.722-.722v-.722H5.167v.722a.724.724,0,0,1-.722.722H3.722A.724.724,0,0,1,3,14.833V9.056Zm8.97,7.215a1.083,1.083,0,1,0-1.083-1.083A1.082,1.082,0,0,0,13.472,11.944Zm-7.944,0a1.083,1.083,0,1,0-1.083-1.083A1.082,1.082,0,0,0,5.528,11.944Zm9.028-3.611-1.083-3.25H5.528L4.444,8.333Z",
    transform: "translate(-3 -4)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_time_to_leave_24px-2",
    "data-name": "ic_time_to_leave_24px",
    d: "M3.95,6.542C3.966,6.534,3,4,3,4H5.771a.637.637,0,0,1,.6.428l.881,2.537v3.389a.425.425,0,0,1-.424.424H6.407a.425.425,0,0,1-.424-.424V9.931H3.95S3.932,6.556,3.95,6.542ZM5.771,8.66a.635.635,0,1,0-.635-.635A.635.635,0,0,0,5.771,8.66Zm.635-2.118L5.771,4.635H3.483l.738,1.906Z",
    transform: "translate(9.559 -2)",
    fill: "#ffffff"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcFleetHover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_fleet_hover.30c973dd2b8785b7cd678f716042ed09.svg";